import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import useRegisterInput from '@afosto/app-components-react/Form/useRegisterInput';
import Checkbox from '@afosto/app-components-react/Checkbox';
import CurrencyField from '@afosto/app-components-react/CurrencyField';
import DateTimePicker from '@afosto/app-components-react/DateTimePicker';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Select from '@afosto/app-components-react/Select';
import TextField from '@afosto/app-components-react/TextField';
import validationSchema from './validations';
import translations from './translations';

const TransactionForm = ({ transaction, onSubmit, onCancel, inline }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    editInline: inline,
    defaultValues: {
      client: transaction?.client ?? null,
      description: transaction?.description ?? '',
      amount: transaction?.amount ?? '',
      amountDue: transaction?.amount_due ?? '',
      amountPaid: transaction?.amount_paid ?? 0,
      isPaid: transaction?.is_paid ?? false,
      currency: transaction?.currency ?? 'EUR',
      createdAt: transaction?.created_at ?? null,
      updatedAt: transaction?.updated_at ?? null,
    },
    onSubmit,
    onCancel,
  });

  useRegisterInput('client', true, form);

  const { setIsEditing } = form;

  useEffect(() => {
    setIsEditing(false);
  }, [transaction, setIsEditing]);

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        {!form.editInline && (
          <CurrencyField
            name="amount"
            label={intl.formatMessage(translations.fields.amount.label)}
            readOnly={form.editInline}
          />
        )}

        <TextField
          name="description"
          label={intl.formatMessage(translations.fields.description.label)}
          readOnly={form.editInline}
        />

        <Select
          name="currency"
          label={intl.formatMessage(translations.fields.currency.label)}
          suggestions={[{ value: 'EUR', label: 'Euro' }]}
          readOnly={form.editInline}
        />

        {form.editInline && (
          <>
            <CurrencyField
              name="amountDue"
              label={intl.formatMessage(translations.fields.amountDue.label)}
              readOnly={form.editInline}
            />

            <CurrencyField
              name="amountPaid"
              label={intl.formatMessage(translations.fields.amountPaid.label)}
              readOnly={form.editInline}
            />

            <Checkbox
              name="isPaid"
              label={intl.formatMessage(translations.fields.isPaid.label)}
              readOnly={form.editInline}
            />

            <DateTimePicker
              name="createdAt"
              label={intl.formatMessage(translations.fields.createdAt.label)}
              readOnly={form.editInline}
            />

            <DateTimePicker
              name="updatedAt"
              label={intl.formatMessage(translations.fields.updatedAt.label)}
              readOnly={form.editInline}
            />
          </>
        )}
      </Form>
    </LoadingWrapper>
  );
};

TransactionForm.propTypes = {
  transaction: PropTypes.object,
  inline: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

TransactionForm.defaultProps = {
  transaction: {},
  inline: false,
  onCancel: undefined,
  onSubmit: undefined,
};

export default TransactionForm;
